import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0f4acc8c"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=0f4acc8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_babb32925cd4b8a8c1892c895ee75fdf/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports